export const HTTP_STATUS_CODE = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHENTICATED: 401,
  FORBIDDEN: 403, // FORBIDDEN_BY_SERVER, UNAUTHORIZED
  NOT_FOUND: 404,
};

export const X_BUBBLETAP_SHARE_TOKEN = 'X-Bubbletap-Share-Token';
